import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../../../context/AuthContext";
import axios from "axios";
import Swal from "sweetalert2";
import { API_BASE_URL } from "../../../../../Helpers/apiConfig";

export const AdminPackageEditIndividual = () => {
    const params = useParams();
    const { t } = useTranslation();
    const { user } = useAuth();

    const [msg, setMsg] = useState("");
    const [loading, setLoading] = useState(true);
    const [loadingCourses, setLoadingCourses] = useState(true);
    const [courses, setCourses] = useState([]);
    const [form, setForm] = useState({
        id: "",
        packageName: "",
        packageDetail: "",
        packagePrice: "",
        howManyDays: "",
        courseId: "",
        isActive: "true"
    });

    const headers = {
        accept: "*/*",
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": "false",
        Authorization: "Bearer " + user.token
    };

    useEffect(() => {
        const fetchAll = async () => {
            try {
                const packageUrl = API_BASE_URL + "/admin/Package/Get";
                const courseUrl = API_BASE_URL + "/admin/CourseManager/GetCourses";

                const [packageRes, courseRes] = await Promise.all([
                    axios({
                        method: "GET",
                        url: packageUrl,
                        params: { id: params.id },
                        headers
                    }),
                    axios({
                        method: "GET",
                        url: courseUrl,
                        headers
                    })
                ]);

                if (packageRes.status === 200 && packageRes.data?.success) {
                    const item = packageRes.data.data;
                    setForm({
                        id: item.id,
                        packageName: item.packageName || "",
                        packageDetail: item.packageDetail || "",
                        packagePrice: item.packagePrice ?? "",
                        howManyDays: item.howManyDays ?? "",
                        courseId: item.sortNumber != null ? String(item.sortNumber) : "",
                        isActive: String(item.isActive)
                    });
                } else {
                    setMsg(packageRes.data?.message || "Paket bilgisi alınamadı.");
                }

                if (courseRes.status === 200 && courseRes.data?.success) {
                    const activeCourses = (courseRes.data.data || []).filter(
                        (course) => course.isDeleted === false && course.isActive === true
                    );
                    setCourses(activeCourses);
                } else {
                    setMsg((prev) => prev || courseRes.data?.message || "Kurslar alınamadı.");
                }
            } catch (err) {
                setMsg(err?.message || "Beklenmedik bir hata oluştu.");
            } finally {
                setLoading(false);
                setLoadingCourses(false);
            }
        };

        fetchAll();
    }, [params.id, user.token]);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setForm((prev) => ({ ...prev, [id]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const url = API_BASE_URL + "/admin/Package/Update";

            const res = await axios({
                method: "PUT",
                url,
                data: {
                    id: form.id,
                    isDeleted: false,
                    packageName: form.packageName,
                    packageDetail: form.packageDetail,
                    packageFeaturedImage: null,
                    packagePrice: Number(form.packagePrice),
                    studentLimit: 1,
                    isActive: form.isActive === "true",
                    howManyDays: Number(form.howManyDays),
                    isInvidual: true,
                    isItPrivate: false,
                    sortNumber: Number(form.courseId)
                },
                headers
            });

            if (res.status === 200 && res.data?.success) {
                await Swal.fire({
                    title: "Güncellendi!",
                    icon: "success",
                    confirmButtonText: "Tamam"
                });
                window.location.reload();
                return;
            }

            setMsg(res.data?.message || "Beklenmedik bir hata oluştu.");
        } catch (err) {
            setMsg(err?.message || "Beklenmedik bir hata oluştu.");
        }
    };

    return (
        <div className="container-fluid py-3 py-md-4">
            <div className="row justify-content-center">
                <div className="col-12 col-lg-9 col-xl-8">
                    <div className="card shadow-sm border-0">
                        <div className="card-body p-3 p-md-4">
                            <div className="text-center mb-4">
                                <h1 className="h3 mb-1">Bireysel Paket Düzenle</h1>
                            </div>

                            {msg ? <div className="alert alert-danger">{msg}</div> : null}

                            {loading ? (
                                <div className="text-center">Yükleniyor...</div>
                            ) : (
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="packageName" className="form-label">
                                            {t("packageName")}
                                        </label>
                                        <textarea
                                            className="form-control"
                                            id="packageName"
                                            value={form.packageName}
                                            onChange={handleChange}
                                            rows={2}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="packageDetail" className="form-label">
                                            {t("packageDescription")}
                                        </label>
                                        <textarea
                                            className="form-control"
                                            id="packageDetail"
                                            value={form.packageDetail}
                                            onChange={handleChange}
                                            rows={3}
                                        />
                                    </div>

                                    <div className="row">
                                        <div className="col-12 col-md-6 mb-3">
                                            <label htmlFor="packagePrice" className="form-label">
                                                {t("packagePrice")}
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                id="packagePrice"
                                                value={form.packagePrice}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        <div className="col-12 col-md-6 mb-3">
                                            <label htmlFor="howManyDays" className="form-label">
                                                {t("validityDate")}
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                id="howManyDays"
                                                value={form.howManyDays}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-12 col-md-6 mb-3">
                                            <label htmlFor="courseId" className="form-label">
                                                Kurs
                                            </label>
                                            <select
                                                id="courseId"
                                                className="form-select"
                                                value={form.courseId}
                                                onChange={handleChange}
                                                required
                                                disabled={loadingCourses}
                                            >
                                                <option value="">
                                                    {loadingCourses ? "Kurslar yükleniyor..." : t("select")}
                                                </option>
                                                {courses.map((course) => (
                                                    <option key={course.id} value={course.id}>
                                                        {course.courseName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="col-12 col-md-6 mb-3">
                                            <label htmlFor="isActive" className="form-label">
                                                {t("isActive")}
                                            </label>
                                            <select
                                                id="isActive"
                                                className="form-select"
                                                value={form.isActive}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="true">{t("active")}</option>
                                                <option value="false">{t("passive")}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="d-grid d-md-flex justify-content-md-center mt-4">
                                        <button type="submit" className="btn btn-primary btn-lg px-4">
                                            {t("update")}
                                        </button>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminPackageEditIndividual;